var React = require('react');

function BotsMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeWidth":".666","transform":"translate(.61 1.173)"},[React.createElement("path",{"d":"M4.94167935,0 C7.67089345,-5.01348505e-16 9.88335869,2.2124652 9.88335869,4.94167935 L9.88335869,9.88335869 C9.88335869,11.4429096 8.61909286,12.7071755 7.05954192,12.7071755 L2.82381677,12.7071755 C1.26426583,12.7071755 1.90989906e-16,11.4429096 0,9.88335869 L0,4.94167935 C-3.34232336e-16,2.2124652 2.2124652,5.01348505e-16 4.94167935,0 Z","key":0}),React.createElement("rect",{"width":"7.06","height":"2.118","x":"1.412","y":"3.53","rx":".998","key":1}),React.createElement("path",{"d":"M4.94167935,7.76549612 L4.94167935,10.5893129","key":2})]));
}

BotsMenu.defaultProps = {"width":"11","height":"15","viewBox":"0 0 11 15"};

module.exports = BotsMenu;

BotsMenu.default = BotsMenu;
